import {
  type SearchResult,
  calculateHighlightRects,
  usePdf,
  usePdfJump,
  useSearch,
} from '@anaralabs/lector';
import { useEffect, useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Command, CommandInput, CommandItem, CommandList } from '../ui/Command';

const SearchItem = ({ result }: { result: SearchResult }) => {
  const { jumpToHighlightRects } = usePdfJump();
  const getPdfPageProxy = usePdf((state) => state.getPdfPageProxy);

  const onSelect = async () => {
    const pageProxy = getPdfPageProxy(result.pageNumber);

    const rects = await calculateHighlightRects(pageProxy, {
      pageNumber: result.pageNumber,
      text: result.text,
      matchIndex: result.matchIndex,
    });

    jumpToHighlightRects(rects, 'pixels');
  };

  return (
    <CommandItem
      className="flex flex-col gap-1"
      value={result.text}
      onSelect={onSelect}
    >
      <span>{result.text}</span>
      <div className="flex justify-between items-center w-full">
        <span className="text-xs text-gray-500">Page {result.pageNumber}</span>
        {/* <span>{result.score * 100}%</span> */}
      </div>
    </CommandItem>
  );
};

export function SearchMenu() {
  const [value, setValue] = useState('');
  const [debouncedSearchText] = useDebounce(value, 500);
  const { searchResults: results, search } = useSearch();

  useEffect(() => {
    search(debouncedSearchText, { limit: 20 });
  }, [debouncedSearchText]);

  const items = useMemo(() => {
    const keywordResults = results.exactMatches;
    const fuzzyResults = results.fuzzyMatches;

    return [...keywordResults, ...fuzzyResults];
  }, [results]);

  return (
    <Command className="bg-background">
      <CommandInput
        autoFocus
        value={value}
        onValueChange={setValue}
        placeholder="Search in the document..."
      />
      <CommandList className="max-h-[unset]">
        {items.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <SearchItem key={index} result={item} />
        ))}
      </CommandList>
    </Command>
  );
}
